import React from "react"
import * as actions from "modules/auth/actions"
import * as appActions from "actions"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import AnimatedPageRoute from "modules/common/components/AnimatedPageRoute"

import LoginComponent from "modules/auth/components/LoginComponent"

const LoginContainer = props => <AnimatedPageRoute><LoginComponent {...props}/></AnimatedPageRoute>

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(Object.assign({}, actions, appActions), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)